<template>
  <el-tabs v-model="card_index" @tab-click="handleClick">
    <el-tab-pane label="固定金额设置" name="MeterOrderAmount">
      <!-- 原有金额叠加，绑定的费项是上限 -->
      <MeterOrderAmount v-if="card_index === 'MeterOrderAmount'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import MeterOrderAmount from "./MeterOrderAmount";
export default {
  name: "MeterOrderFixedMain",
  components: {MeterOrderAmount},
  data() {
    return {
      card_index: "MeterOrderAmount"
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderFixedMain.vue